import React, { useCallback, useRef } from 'react'
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { EnhancementViewLevel } from '../../ReportViewLevelSelector/types'

interface ChartViewLevelSelectorProps {
  value: EnhancementViewLevel
  onViewLevelChange: (level: EnhancementViewLevel) => void
  disabled?: boolean
  dataTestId?: string
}

function ChartViewLevelSelector({ 
  value, 
  onViewLevelChange, 
  disabled = false, 
  dataTestId 
}: ChartViewLevelSelectorProps) {

  const stableId = useRef(`chart-selector-${Math.random().toString(36).substr(2, 9)}`).current
  const labelId = `${stableId}-label`
  
  const handleChange = useCallback((event: SelectChangeEvent) => {
    onViewLevelChange(event.target.value as EnhancementViewLevel)
  }, [onViewLevelChange])

  return (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel id={labelId} sx={{ fontSize: '0.875rem' }}>
        View
      </InputLabel>
      <Select
        labelId={labelId}
        id={stableId}
        value={value}
        label="View"
        onChange={handleChange}
        disabled={disabled}
        data-testid={dataTestId}
        MenuProps={{
          disableScrollLock: true,
        }}
        sx={{
          fontSize: '0.875rem',
          '& .MuiSelect-select': {
            paddingY: 1,
          },
        }}
      >
        <MenuItem value={EnhancementViewLevel.DEPARTMENT} sx={{ fontSize: '0.875rem' }}>
          {EnhancementViewLevel.DEPARTMENT}
        </MenuItem>
        <MenuItem value={EnhancementViewLevel.TEAM} sx={{ fontSize: '0.875rem' }}>
          {EnhancementViewLevel.TEAM}
        </MenuItem>
        <MenuItem value={EnhancementViewLevel.EMPLOYEE} sx={{ fontSize: '0.875rem' }}>
          {EnhancementViewLevel.EMPLOYEE}
        </MenuItem>
      </Select>
    </FormControl>
  )
}

export default ChartViewLevelSelector